export const DISPLAY_LABEL_FALLBACK = '--';